<template>
    <main>
         <div>
            <div class="card text-center" style="padding: 10px 5% 10px; min-height:200px" >
                <div>
                </div>
                <div class="card-body" style="margin:auto;">
                          
                   <div class="J-galery-container">
                       <div class="J-galary-icon">
                            <i class="fas fa-file-import"></i>
                       </div>
                       <div class="J-croppa-image">
                            <croppa v-model="myCroppa" prevent-white-space :width="360" :height="360" placeholder=""></croppa>
                       </div>
                   </div>

                </div>
                <br>
                <br>
                <div>
                    <v-btn x-large color="#11679a" dark outline @click="saveImage('image/jpeg')">Agregar </v-btn>
                </div>
            </div>
         </div>
    </main>
</template>
<script>
    import { EventBus } from '@/helpers/eventbus/event-bus'
    
    export default {
        data(){
            return{
                count:0,
                countClass:"active30",
                flareExample:null,
                valFinish:0,
                tween:null,
                isScanning:false,
                myCroppa: {},

            }
        },
        mounted(){
        },
        methods:{
            recuvaUrl(blobUrl){


                var _this=this
                var xhr = new XMLHttpRequest;
                xhr.responseType = 'blob';

                xhr.onload = function() {
                var recoveredBlob = xhr.response;

                var reader = new FileReader;
                    reader.onload = function() {
                        var blobAsDataUrl = reader.result;
                        URL.revokeObjectURL(blobUrl);
                        EventBus.$emit("uploadImage",blobAsDataUrl)
                        _this.$emit('close')
                    };
                    reader.readAsDataURL(recoveredBlob);
                };
                console.log(blobUrl)


                xhr.open('GET', blobUrl);
                xhr.send();
            },
           saveImage(type, compressionRate) {
               console.log(compressionRate)
                this.myCroppa.generateBlob((blob) => {
                    var url = URL.createObjectURL(blob);
                    this.recuvaUrl(url)
                    // EventBus.$emit("uploadImage",url)
                    // this.$emit('close')
                }, type, compressionRate)

                // var url=this.myCroppa.generateDataUrl();
                // EventBus.$emit("uploadImage",url)
                // this.$emit('close')
            },
        }

    }
</script>